import { ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, Injectable, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent, IsGroupOpenByDefaultParams, RowGroupingDisplayType, SideBarDef, ModuleRegistry, DetailGridInfo, ExcelStyle, ExcelRow, ProcessRowGroupForExportParams } from 'ag-grid-community';
import moment from 'moment';
import { NumberPipe } from 'src/app/pipe/number.pipe';
import { DialogService } from 'src/app/services/dialog.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { AgGridAngular } from 'ag-grid-angular';
import { FilterService } from 'src/app/services/filter.service';
import { debounceTime, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { SessionStorage } from 'angular-web-storage';
import { ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { NavigationService } from 'src/app/services/navigation.service';
import { UserActivityService } from 'src/app/services/useractivity.service';
import { EnhancementService } from 'src/app/services/enhancements-service';
import { rowEditComponent } from './row-edit-component';
import config from '../../../widget/grid-page/config';
import { BasicLineChartGridComponent } from 'src/app/components/shared/charts/hierarchical-custom-component/basic-line-chart-grid.component';
import { StatusJourneyViewComponent } from '../hierarchical-custom-component/status-journey-view/status-journey-view.component';
import { BasicBarChartGridComponent } from '../hierarchical-custom-component/basic-bar-chart-grid.component';

// Cell Renderer Params
function MyCellRenderer() { }

MyCellRenderer.prototype.init = function (params: any) {
  this.eGui = document.createElement('span');
  this.eGui.innerHTML = '&nbsp;' + params.value + '&nbsp;';
  this.eGui.style.backgroundColor = params['res'].isTextColorWithOpacity || '#00000040';
  this.eGui.style.color = params['res'].isTextColorWithOpacityColor || '#fff' ;
  this.eGui.style['border-radius'] = '2px';
  this.eGui.style['padding'] = '0 5px';
};

MyCellRenderer.prototype.getGui = function () {
  return this.eGui;
};

// Cell Renderer Params End

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-hierarchical-grid-chart',
  templateUrl: './hierarchical-grid-chart.component.html',
  styleUrls: ['./hierarchical-grid-chart.component.scss']
})
export class HierarchicalGridChartComponent implements OnInit, OnChanges {

  // Inputs
  @Input('data') data: any;
  @Input('pageKey') pageKey: any;
  @Input('item') item: any;
  @Input('config') config: any;
  @Input('headerConfig') headerConfig: any;
  @Input('error_name') error_name: any;
  @Input('heading') heading: string = '';
  @Input('rowData') rowData: any = [];
  @Input('columnDefs') public columnDefs: any = [];
  @Input('inputConfig') public inputConfig: any = [];
  @Input('childColumnDefs') public childColumnDefs: any = [];
  @Input('selectedGroup') selectedGroup: any;
  @Input('selectedHeader') selectedHeader: any;
  @Input('loader') public loader: Boolean = true;
  @Input('isDetailGrid') public isDetailGrid: Boolean | any = false;
  @Input('isPivotGrid') public isPivotGrid: Boolean | any = false;
  @Input('groupDisplayType') public groupDisplayType: RowGroupingDisplayType = 'multipleColumns';
  @Input('dividerVisibility') public dividerVisibility: Boolean | any = true;
  @Input('contextMenuCondition') public contextMenuCondition: Boolean | any = true;
  @Input('detailRowAutoHeight') public detailRowAutoHeight: Boolean | any = true;
  @Input('connectingCustomDetail') public connectingCustomDetail: Boolean | any = false;
  @Input('detailComponent') public detailComponent: any;

  // View Childs
  @ViewChild('fs') fs!: ElementRef;
  @ViewChild('pdfTable') pdfTable!: ElementRef;
  @ViewChild("pdfSettingGrid", { static: true }) pdfSettingGrid!: ElementRef;
  @ViewChild("paymentGrid") paymentGrid!: AgGridAngular;
  @ViewChild('paymentHGridDiv', { static: true }) paymentHGridDiv!: ElementRef;

  // Host Binds and HostListners
  @HostBinding('class.is-fullscreen') isFullscreen = false;

  private gridApi!: GridApi | any;
  public sideBar: SideBarDef | string | string[] | boolean | null = 'columns';

  isActive = false;
  currentVisibleData: any = [];
  columnApi: any;
  isIcon: any;

  iconList: any = [];
  condition: any;
  isDataLoaded: boolean = false;
  reqSubcription: Subscription[] = [];

  agGroupedData: any;
  GroupedData: any
  childData: any = [];
  parentData: any = [];
  minRowHeight: any;
  rowGroupingDisplayIcon: any;
  gridRowColor = false;
  pagination: any;
  pageSizeCount: any;
  cardName: any;
  filterValue: any;
  pdfColumnDefs: any;
  dashboardKey: any;
  tabId: any;
  grandTotalRow:any={};
  displayMode: string = 'number'; // Track current display mode: 'number' or 'percentage'
  selectedType: any;
  originalColumnDefs: any = []; // Store original column definitions
  isToggleGroup: boolean = false; // Flag to enable toggle group functionality
  groupHeaderToggleValue: string = ''; // Value to toggle in group headers
  aggFunctionType: string = 'sum'; // Type of aggregation function to apply
  toggleColumnMap: Map<string, any> = new Map(); // Map to store number-percentage column pairs
  originalRowData: any[] = []; // Store original unfiltered row data for territory filtering
  selectedInstitution: any[] = []; // Store selected institutions from scatter chart
  isFilteredByTerritory: boolean = false; // Track if data is filtered by territory
  lastRowFilterKey: string = ''; // Store last-used rowFilterKey for re-applying filter

  // weightedPctAgg memoization: filter + total_patients sum are shared across all percentage columns for the same node
  private _weightedPctCacheRowData: any = null;
  private _weightedPctCacheByNode = new WeakMap<any, { groupRows: any[]; sumTotal: number; fieldSums: Map<string, number> }>();

  public defaultColDef: ColDef = {
    flex: 1,
    resizable: true,
    filter: true,
    sortable: true,
    unSortIcon: true,
    // suppressMenu: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxWidth: 350,
    minWidth: 80,
    wrapText: true,
  };
  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
    maxWidth: 350,
    sortable: false,
    cellRendererParams: {
      suppressCount: true,
    },
    cellClass: "cell-wrap-text-h"
  }

  // Detail Grid gridConfiguration
  public detailCellRendererParams: any = {
    detailGridOptions: {
      columnDefs: [],
      defaultColDef: {
        flex: 1,
        resizable: true,
        sortable: true,
        unSortIcon: true,
        draggable: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        wrapText: true,
        suppressMenu: true,
        // maxWidth: 350,
      },
      suppressAggFuncInHeader: true,
      suppressDragLeaveHidesColumns: true,
      rowHeight: 50,
      getRowStyle: this.getRowStyle.bind(this)
    },
    designerCellRendererParams: {
    },
    getDetailRowData: (params: any) => {
      params.successCallback(params.data.callRecords);
    },
  }

  frameworkComponents = {
    statusJourneyViewComponent: StatusJourneyViewComponent,
    basicLineChartGridRenderer: BasicLineChartGridComponent,
    basicBarChartGridComponent: BasicBarChartGridComponent
  };

  public groupRowRendererParams: any = {
    suppressCount: true,
  }
  
  @HostListener("fullscreenchange", ["$event"])
  @HostListener("webkitfullscreenchange", ["$event"])
  @HostListener("mozfullscreenchange", ["$event"])
  @HostListener("MSFullscreenChange", ["$event"])
  screenChange(event:any) {
    if (!document.fullscreenElement) {
      this.closeFullscreen();
    }
  }
  closeFullscreen() {
    this.isFullscreen = false;
    this.isActive = false;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.refreshGridAfterResize();
  }

  constructor(
    private currency: CurrencyPipe,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    public filterService: FilterService,
    private navigationService: NavigationService,
    private userActivityService: UserActivityService,
    private enhancementService: EnhancementService
  ) {
    this.reqSubcription.push(this.filterService.chartshowBy.subscribe((res: any) => {
      this.condition = res
    }))
    this.filterService.intractiveFilter
        .pipe(debounceTime(500))
        .subscribe((res: any) => {})

    // Subscribe to intractiveClickTrigger to receive selectedInstitutions from scatter chart
    this.reqSubcription.push(
      this.filterService.intractiveClickTrigger.subscribe((payload: any) => {
        // Support structured payload { institutions, rowFilterKey } or legacy plain array
        const institutions: any[] = Array.isArray(payload) ? payload : (payload?.institutions || []);
        const rowFilterKey: string = Array.isArray(payload) ? '' : (payload?.rowFilterKey || '');
        if (institutions && institutions.length > 0) {
          this.filterRowDataByTerritoryKey(institutions, rowFilterKey);
        } else {
          this.resetTerritoryFilter();
        }
      })
    );
  }
excelStyles: ExcelStyle[] = [
    {
      id: "numberType",
      numberFormat: {
        format: "0",
      },
    },
    {
      id: "currencyFormat",
      numberFormat: {
        format: "#,##0.00 €",
      },
    },
    {
      id: "negativeInBrackets",
      numberFormat: {
        format: "$[blue] #,##0;$ [red](#,##0)",
      },
    },
    {
      id: "booleanType",
      dataType: "Boolean",
    },
    {
      id: "stringType",
      dataType: "String",
    },
    {
      id: "dateType",
      dataType: "DateTime",
    },
    {
      id: "header",
      font: { bold: true },
      alignment: { wrapText: true },
    },
    {
      id: "cell",
      alignment: { wrapText: true },
    },
  ];

  openPDFcustom(event?:any) {
    this.dialogService.openDialog(this.pdfSettingGrid, "80vw")
  }

  screenChanges(fullscreen: any) {
    this.isFullscreen = fullscreen;
    this.isActive = fullscreen;
    if (!fullscreen) {
      this.refreshGridAfterResize();
    }
  }

  refreshGridAfterResize() {
    if (this.gridApi) {
      setTimeout(() => {
        // Force the grid to recalculate its layout after the container resize
        this.gridApi.setRowData(this.rowData);
        this.gridApi.sizeColumnsToFit();
      }, 300);
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.filterService.hiraricalGridApi = params.api
    this.columnApi = params.columnApi;
    this.gridApi.addEventListener('rowGroupOpened', this.onRowGroupOpened.bind(this));
    // this.autoSizeAll(false)

  }
  // onBtStartEditing() {
  //   this.gridApi.setFocusedCell(0, "action_taken");
  //   this.gridApi.startEditingCell({
  //     rowIndex: 0,
  //     colKey: "action_taken",
  //   });
  // }
  onRowGroupOpened(event: any): void {
    this.filterService.allGroupsClosed = false;
    this.gridApi.forEachNode((node: any) => {
      if (node.group && node.expanded) {
        this.filterService.allGroupsClosed = true;
      }
    });
  }

  onFirstDataRendered(params: any) {
    params.columnApi.autoSizeColumn('ag-Grid-AutoColumn');
  }

  // Quick Filter for Type to Search Filter
  onQuickFilterChanged(event: any) {
    this.filterValue = event;
    this.gridApi.setQuickFilter(this.filterValue);
  }

  exportToPdf(event:any) {
    // debugger
    this.openPDFcustom(event);
  }
  changeDisplays(value: any) {
    let newDisplayMode: string = '';

    // Extract configuration values if provided
    if (typeof value === 'object') {
      this.isToggleGroup = value.isToggleGroup ?? this.isToggleGroup;
      this.groupHeaderToggleValue = value.groupHeaderToggleValue ?? this.groupHeaderToggleValue;
      this.aggFunctionType = value.aggFunctionType ?? this.aggFunctionType;
      newDisplayMode = value.displayMode?.toLowerCase() || '';
    } else if (typeof value === 'string') {
      newDisplayMode = value.toLowerCase();
    }

    // Only toggle number/percentage columns if value is a recognized display mode
    // and there are actually toggleable column pairs
    if ((newDisplayMode === 'percentage' || newDisplayMode === 'number') && this.toggleColumnMap.size > 0) {
      this.displayMode = newDisplayMode;
      this.updateColumnDefsForDisplayMode();

      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
        this.gridApi.refreshCells({ force: true });
      }
    }

    // Apply group toggle if enabled
    if (this.isToggleGroup && this.gridApi) {
      this.applyGroupHeaderToggle();
    }
  }
  
  // Helper: extract all leaf (non-group-header) columns from potentially nested columnDefs
  private getLeafColumns(cols: any[]): any[] {
    const leaves: any[] = [];
    for (const col of cols) {
      if (col.children && Array.isArray(col.children)) {
        leaves.push(...this.getLeafColumns(col.children));
      } else {
        leaves.push(col);
      }
    }
    return leaves;
  }

  // Recursively update column defs, handling group header wrappers with children
  // Swaps _pct columns into the number column's position to preserve order
  private updateColumnsRecursive(cols: any[]): any[] {
    const result: any[] = [];
    for (const col of cols) {
      if (col.children && Array.isArray(col.children)) {
        result.push({ ...col, children: this.updateColumnsRecursive(col.children) });
        continue;
      }

      const baseField = col.field?.replace(/_pct$/, '');
      const isPctField = col.field?.endsWith('_pct');

      if (baseField && this.toggleColumnMap.has(baseField)) {
        if (this.displayMode === 'percentage') {
          if (isPctField) {
            // Skip _pct at its original position; it was already placed at the number column's slot
            continue;
          } else {
            // Replace the number column with its _pct counterpart to keep the same position
            const pair = this.toggleColumnMap.get(baseField);
            const pctCol = { ...pair.percentage };
            pctCol.hide = false;
            pctCol.type = 'Percentage';
            // Always use weightedPctAgg for percentage mode — calculates count / total_patients
            pctCol.aggFunc = 'weightedPctAgg';
            // Calculate percentage from count column / total_patients instead of using pre-calculated _pct values
            const countField = baseField;
            pctCol.valueGetter = (params: any) => {
              if (!params.data) return null; // group rows handled by aggFunc
              const count = Number(params.data[countField]) || 0;
              const totalPatients = Number(params.data['total_patients']) || 0;
              if (totalPatients === 0) return 0;
              return (count / totalPatients) * 100;
            };
            pctCol.valueFormatter = (params: any) => {
              if (params.value === null || params.value === undefined || params.value === '') return '';
              const val = Number(params.value) || 0;
              return val.toFixed(2) + '%';
            };
            result.push(pctCol);
          }
        } else {
          if (isPctField) {
            // Skip _pct column in number mode
            continue;
          } else {
            // Show number column as-is
            const updatedCol = { ...col };
            updatedCol.hide = false;
            updatedCol.type = col.selectedRowConfig?.isDataType || 'Number';
            const aggFunc = this.getAggregationFunctionFromConfig(col) || this.getAggregationFunction('number');
            if (aggFunc) updatedCol.aggFunc = aggFunc;
            if (col.selectedRowConfig?.isDataType !== 'percentage' && updatedCol.valueFormatter) {
              delete updatedCol.valueFormatter;
            }
            result.push(updatedCol);
          }
        }
      } else {
        // Non-toggleable column, keep as-is
        result.push(col);
      }
    }
    return result;
  }

  // Update column definitions to switch between number and percentage fields
  updateColumnDefsForDisplayMode() {
    if (!this.originalColumnDefs || this.originalColumnDefs.length === 0) {
      // Backup original column definitions on first call
      this.originalColumnDefs = JSON.parse(JSON.stringify(this.columnDefs));
      // Build the toggle column map
      this.buildToggleColumnMap();
    }

    // Early return if no toggleable column pairs exist
    if (this.toggleColumnMap.size === 0) return;

    // Identify runtime-added columns not in originalColumnDefs
    const originalFieldSet = new Set(this.getLeafColumns(this.originalColumnDefs).map((c: any) => c.field).filter(Boolean));
    const runtimeColumns = this.getLeafColumns(this.columnDefs).filter((c: any) => c.field && !originalFieldSet.has(c.field));

    // Recursively update, preserving group header structure
    const updatedCols = this.updateColumnsRecursive(this.originalColumnDefs);

    // Preserve runtime-added columns that aren't in the original definitions
    this.columnDefs = [...updatedCols, ...runtimeColumns];
  }
  
  // Build a map of toggleable column pairs (number and percentage variants)
  buildToggleColumnMap() {
    this.toggleColumnMap.clear();

    // Extract all leaf columns (handles both flat and nested group header structures)
    const leafColumns = this.getLeafColumns(this.originalColumnDefs);

    // Create a map of base field names to check for pairs
    const fieldMap = new Map<string, { number?: any, percentage?: any }>();

    leafColumns.forEach((col: any) => {
      if (!col.field) return;

      const baseField = col.field.replace(/_pct$/, '');
      const isPctField = col.field.endsWith('_pct');

      if (!fieldMap.has(baseField)) {
        fieldMap.set(baseField, {});
      }

      const pair = fieldMap.get(baseField)!;
      if (isPctField) {
        pair.percentage = col;
      } else {
        pair.number = col;
      }
    });
    
    // Only add to toggleColumnMap if both variants exist
    fieldMap.forEach((pair, baseField) => {
      if (pair.number && pair.percentage) {
        this.toggleColumnMap.set(baseField, pair);
      }
    });
    
    // Also check in rowData for additional validation
    if (this.rowData && this.rowData.length > 0) {
      const sampleRow = this.rowData[0];
      this.toggleColumnMap.forEach((pair, baseField) => {
        const hasNumberField = sampleRow.hasOwnProperty(baseField);
        const hasPctField = sampleRow.hasOwnProperty(`${baseField}_pct`);
        
        // Remove from map if data doesn't support both fields
        if (!hasNumberField || !hasPctField) {
          this.toggleColumnMap.delete(baseField);
        }
      });
    }
  }
  
  // Check if a field has a percentage variant in the column definitions
  hasPercentageVariant(field: string): boolean {
    const baseField = field.replace(/_pct$/, '');
    return this.toggleColumnMap.has(baseField);
  }

  // Get aggregation function from column configuration
  getAggregationFunctionFromConfig(col: any): string | Function | null {
    // Check if column has aggregation configuration
    if (col.selectedRowConfig?.isAggFunc && col.selectedRowConfig?.isAggFuncSelection) {
      return col.selectedRowConfig.isAggFuncSelection;
    }
    
    // Check if column already has aggFunc defined
    if (col.aggFunc) {
      return col.aggFunc;
    }
    
    return null;
  }
  
  // Get aggregation function based on display mode and aggFunctionType
  getAggregationFunction(displayType: string): string | Function {
    // If aggFunctionType is specified, use it
    if (this.aggFunctionType && this.aggFunctionType !== 'sum') {
      // Map common aggregation types
      const aggFuncMap: any = {
        'sum': 'sum',
        'avg': 'avg',
        'average': 'avg',
        'min': 'min',
        'max': 'max',
        'count': 'count',
        'custom': 'custom',
        'roundSum': 'roundSum',
        'colorAggrSum': 'colorAggrSum',
        'sumWithPercent': 'sumWithPercent',
        'sumWithPercentTotal': 'sumWithPercentTotal'
      };
      
      return aggFuncMap[this.aggFunctionType.toLowerCase()] || this.aggFunctionType;
    }
    
    // Default behavior: percentage uses weighted calculation, number uses sum or original
    if (displayType === 'percentage') {
      return 'weightedPctAgg';
    } else {
      return 'sum'; // default fallback
    }
  }

  // Apply group header toggle based on groupHeaderToggleValue
  applyGroupHeaderToggle() {
    if (!this.gridApi || !this.groupHeaderToggleValue) return;
    
    // Iterate through all nodes and apply toggle logic
    this.gridApi.forEachNode((node: any) => {
      if (node.group) {
        // Check if the group key matches the toggle value
        if (node.key === this.groupHeaderToggleValue) {
          // Expand the matching group
          node.setExpanded(true);
        } else if (this.isToggleGroup) {
          // Collapse other groups if toggle is exclusive
          node.setExpanded(false);
        }
      }
    });
    
    // Refresh the grid to show changes
    this.gridApi.onGroupExpandedOrCollapsed();
  }

  ngOnInit(): void {
    // Route
    this.route.params.subscribe((p: any) => {

      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
        this.tabId = params["tab_id"];
      })
    });

    // Initialize toggle group configuration from item config
    if (this.item?.config) {
      this.isToggleGroup = this.item.config['isToggleGroup']?.value === 'yes' || false;
      this.groupHeaderToggleValue = this.item.config['groupHeaderToggleValue']?.name || '';
      this.aggFunctionType = this.item.config['aggFunctionType']?.name || 'sum';
      
      // Initialize display mode from config if available
      const initialDisplayMode = this.item.config['initialDisplayMode']?.name?.toLowerCase() || 'number';
      if (initialDisplayMode === 'percentage' || initialDisplayMode === 'number') {
        this.displayMode = initialDisplayMode;
      }
    }
    
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    const defaultSelectionToggle = this.headerConfig?.find((fnd: any) => fnd.value == "selection_toggle");
    this.selectedType = this.filterService.getSelectionToggle(widgetKey) ?? (defaultSelectionToggle?.toggle_btn?.[0]?.value);

    if (this.selectedType !== undefined && this.selectedType !== null) {
      this.changeDisplays(this.selectedType);
    }

    // For Pivot Side bars
    this.sideBar = {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            suppressValues: false,
            suppressPivots: false,
            suppressPivotMode: true,
            suppressRowGroups: false,
            // suppressSideButtons: false,
            // suppressColumnFilter: false,
            // suppressColumnExpandAll: false,
            // suppressColumnSelectAll: false,
            // suppressSyncLayoutWithGrid: true,
          },
        },
      ],
      position: 'right',
    };

    // For Icons
    this.iconList = this.item?.config?.icon ? this.item?.config?.icon : this.iconList;

    this.isIcon = this.headerConfig.find((f: any) => f.icon_selected);

    // Event Listner for ------
    document.addEventListener('fullscreenchange', (event) => {
      if (document.fullscreenElement) {
        document.getElementById('pdfAgTable')?.setAttribute('style', 'height:90dvh;')
      } else {
        document.getElementById('pdfAgTable')?.setAttribute('style', 'height:inherit;')
      }
    })

    this.detailCellRendererParams.detailGridOptions.columnDefs = this.childColumnDefs;
    
    let detail = this.item.config["list_of_api_detail"] || {};

    this.detailCellRendererParams.designerCellRendererParams = {
      xAxis: this.item?.config?.['x_axis_line']?.api_resp_column_nm,
      yAxis: this.item?.config?.['y_axis_line']?.api_resp_column_nm,
      sourceVar: this.item?.config?.['value_column_line']?.api_resp_column_nm,
      labelVar: this.item?.config?.['label_line'],
      apiKey: detail?.api_key || 200228,
      endpoint: this.item.config?.['widget_endpoint'] || ''
    };

    if (this.item.config?.['comments_action_button']?.value == 'yes') {
      let cfg = this.item.config || {};

      this.columnDefs.push({
        headerName: "Actions",
        field: "action",
        maxWidth: 120,
        headerComponentParams: {
          template: `
                <div class="ag-cell-label-container" role="presentation">
                  <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="justify-content: ${cfg.isActionHeaderAlign || 'start'};text-align: ${cfg.isActionHeaderAlign || 'start'};padding-right: 5px;">
                      <span class="ag-header-cell-text" style="color: ${cfg.isActionHeaderColor || '#7c7c7c'};">
                        ${ "Actions" }
                      </span>
                      <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                  </div>
                  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" style="position: absolute;margin: -5px;"></span>
                </div>
              `
        },
        cellRenderer: rowEditComponent,
        cellRendererParams: (params: any) => ({
          config: this.inputConfig,
          api_key: cfg?.comments_api_key,
          single_source: cfg?.['single_src_action']?.value === 'yes' ? true : false,
      }),
         minwidth: 60
      })
    }




  }

  // Function to define row styles
  getRowStyle(params: any): any {
    if (params.node.rowIndex % 2 === 0) {
      // Even row
      return { background: '#FAFAFB' }; // Set your background color
    } else {
      // Odd row
      return {};
    }
  }

  // Grid options for ag-Grid
  gridOptions: any = {
    components: {
      myCellRenderer: MyCellRenderer,
    },
    columnTypes: {
      Number: {},
      Currency: {},
      Percentage: {},
      String: {},
      string: {},
      integer: {},
      date: {},
    },
    suppressPropertyNamesCheck: true,
    getRowStyle: this.getRowStyleInParent.bind(this),
    onCellClicked: this.onCellClicked.bind(this),
    // onFirstDataRendered: this.onFirstDataRendered.bind(this),
    // onGridReady: this.onFirstDataRendered.bind(this)
    getContextMenuItems: (params:any) => {
      return [
        'copy', // Default copy options
        'copyWithHeaders', // Default copy with headers option
        'copyWithGroupHeaders', // Default copy with group headers option
        'paste', // Default paste option
        {
          name: 'Export to Excel',
          action: () => this.exportXls(),
        },
      ];
    },
  };

  onCellClicked(event: any) {
    this.userStateGenerated();
  }

  // Function to define row styles
  getRowStyleInParent(params: any): any {
    return { padding: '5px 0' }; // Add space between rows (e.g., 5px top and bottom)
  }


  ngOnChanges(changes: SimpleChanges): void {

    let selectedRow: any = [];
    this.selectedGroup?.forEach((res: any) => {
      selectedRow.push(res.api_resp_column_nm)
    });

    // Backup original column definitions when they first come in or change
    if (changes['columnDefs']?.currentValue && changes['columnDefs']?.currentValue !== changes['columnDefs']?.previousValue) {
      console.log(this.columnDefs)
      this.originalColumnDefs = JSON.parse(JSON.stringify(this.columnDefs));
      // Build toggle column map
      this.buildToggleColumnMap();
      // Apply current display mode to new column definitions
      this.updateColumnDefsForDisplayMode();
    }

    this.pdfColumnDefs = this.columnDefs.filter((f: any) => !f.suppressPDFColumn)

    let page = this.item.config?.['isPagination']?.name || 'NIL';
    this.pagination = page == 'NIL' ? false : true;
    this.pageSizeCount = this.pagination ? Number(page) : 0;

    this.minRowHeight = this.item.config?.['minRowHeight'] || 50;
    this.rowGroupingDisplayIcon = this.item.config?.['rowGroupingDisplayIcon']?.value || 'arrow';
    let gridColor = this.item.config?.['GridRowColor']?.name || 'Odd Color';
    this.gridRowColor = gridColor == 'Odd Color' ? true : false;

    let notAdjust = this.item.config?.['headerAdjusting']?.value || 'adjust';
    if (notAdjust == 'fit') {
      if (this.columnApi) {
        this.autoSizeAll(false);
      }
    }

    // Only set row data when rowData actually changed to avoid overwriting territory-filtered data
    if (this.gridApi && changes['rowData']) {
      this.gridApi.setRowData(this.rowData);
    }

    // User State for Grid
    this.restoreState();

    if (changes['rowData']?.currentValue != changes['rowData']?.previousValue) {

      // Store original row data for territory filtering
      if (this.rowData && this.rowData.length > 0) {
        this.originalRowData = JSON.parse(JSON.stringify(this.rowData));

        // If territory filter is active, re-apply it to the new data
        if (this.isFilteredByTerritory && this.selectedInstitution.length > 0) {
          this.filterRowDataByTerritoryKey(this.selectedInstitution, this.lastRowFilterKey);
        } else {
          this.isFilteredByTerritory = false;
        }
      }

      if (this.rowData.length && (this.item.config?.['grand_total']?.value == 'yes') ) {
        this.grandTotalRow = this.calculateGrandTotalRow(this.rowData, this.columnDefs);
      }

      setTimeout(() => {
        this.GroupedData = this.getGroupedData();
      }, 500);
    }
  }


  // Export Pdf
  exportToExcel() {
    this.exportXls();
  }
  exportXls() {
    this.gridApi.exportDataAsExcel({
      fileName: this.item.config['report_heading'], columnKeys: this.generateColumnsForExcel(),
      sheetName: this.filterService.selectedBrandName || this.item.config['report_heading'],
      processCellCallback: (params: any) => {
        // debugger
        let suffix = params.column.colDef?.selectedRowConfig?.issuffix || '';
        let prefix = params.column.colDef?.selectedRowConfig?.isPrefix || '';
        
        if (params.column.colDef.type === "date") {
          params.value = moment(params.value).format("MM/DD/YYYY")
          if (params.value == 'Invalid date') { return '' }
          return params.value;
        }
        // if (params.column.colDef.valueFormatter) {
        //   return params.column.colDef.valueFormatter({ value: params.value });
        // }
        
        let maskColumn = this.item.config['maskCurrentQuarter']?.name == 'Yes' ? true : false;
        
        // let parent = this.item.config["list_of_api_parent"]
        
        if (params.column.colDef.type === "Currency") {
          if(maskColumn && this.enhancementService.currentQuarterFlag) {
            return '-'
          } else {
            let val = params.value ? params.value : 0;
            return this.currency.transform(Number(val));
          }
        }
        if (params.column.colDef.type === "Number") {
          if(typeof params.value == 'number') {
            return prefix + this.currency.transform(Number(params.value), "", "", "1.0-2") + suffix;
          } else {
            if (params.value == "-" || params.value == null) return "-";
            if (isNaN(Number(params.value))) return prefix + "" + params.value + "" + suffix;
            return prefix + "" + this.currency.transform(Number(params.value), "", "", "1.0-2") + "" + suffix;
            // return this.currency.transform(Number(params.value), "", "", "1.0-2")
          }
        }
        if (params.column.colDef.type === "Percentage") {
          if(maskColumn && this.enhancementService.currentQuarterFlag) {
            return '-'
          } else {
            let val = params.value ? params.value : 0;
            return val + '%'
          }
        }
        return params.value;
      },
      getCustomContentBelowRow: (params: any) => {
        if (this.isDetailGrid) {
          return this.getDetailExcelRows(params) as ExcelRow[];
        }
        return [];
      }
    });
  }

  // For Excel Generation
  generateColumnsForExcel(): string[] {
    const keys = this.columnApi.getAllDisplayedColumns()
      .map((column: any) => column.getColId())
    return keys;
  }

  // Grouped Data
  getGroupedData() {
    // let rowGroupData: any = [];
    // const rowNodes = this.gridApi?.rowModel?.rowsToDisplay //getDisplayedRowAtIndex(0)?.allLeafChildren;
    const displayedRows: any = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
      if (node.aggData) {
        const group = {
          'file_type_name': node.key, 'tran_date': '', "error_bucket": " ",
          "delay_bucket": " ",
        };
        displayedRows.push(Object.assign({}, group, node.aggData));
      }
    });
    // console.log(displayedRows);
    return displayedRows;
  }

  // On Load Opened Tree
  public isGroupOpenByDefault: (params: IsGroupOpenByDefaultParams) => boolean =
    (params: IsGroupOpenByDefaultParams) => {
      // User State for opened Tree
      if(this.userActivityService.hierarchicalGridState?.length==0) return false;
      let findState = this.userActivityService.hierarchicalGridState.find((o:any)=> o.dash_key == this.dashboardKey && o.tab_id == this.tabId);
      if(!this.columnApi) return false;
      if(!findState) return false;
      
      if(findState?.getRenderedRow?.length==0) return false;

      let findExpention = findState.getRenderedRow.find((data:any) => data.expanded && data.group && params.field == data.field && params.key == data.key)

      return findExpention ? true : false
  };

  // Auto width Size for ALL the Columns
  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = [];
    this.columnApi.getAllColumns()!.forEach((column: any) => {
      allColumnIds.push(column.getId());
    });
    this.columnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  expendCol(event: any) {
    // debugger
    if (event) {
      this.gridApi.expandAll();
    } else {
      this.gridApi.collapseAll()
    }
  }

  matchObjects(obj1: any, obj2: any) {
    return Object.keys(obj2).every(key => obj1[key] == obj2[key]);
  }

  // Custom Agg 
  public aggFuncs: any = {
    'custom': (params: any) => {

      let finalValue = 0;

      if (this.rowData?.length > 0 && params.rowNode?.field && params.rowNode?.group) {

        let node = params.rowNode || params.node;
        let level = node?.level;
        let condition: any = {};
        condition = {};

        for (let index = 0; index <= level; index++) {
          condition[node.field] = node.key;
          node = node.parent;
        }

        let newData = this.rowData.filter((res: any) => {
          return Object.keys(condition).every(key => res[key] === condition[key]);
        });

        // let newData = this.rowData.filter((flr: any) => flr[params?.rowNode?.field] == params?.rowNode?.key);

        const value = params.colDef.selectedRowConfig.aggValueColumnName;
        const maxValue = params.colDef.selectedRowConfig.aggMaxValueColumnName;

        const newValue = newData.reduce((acc: any, name: any) => acc + name[value], 0);
        const newMaxValue = newData.reduce((acc: any, name: any) => acc + name[maxValue], 0);

        // const sum = newValue + newMaxValue;

        // 1+2
        // 2/3*100
        if (newMaxValue == 0 && newValue == 0) {
          finalValue = 0;
        } else {
          finalValue = (newValue / newMaxValue) * 100;
        }

        return finalValue;
      }
    },
    'roundSum': (params: any) => {

      if (this.rowData?.length > 0 && params.rowNode?.field) {
        const values = params.values;
        let sum = values.reduce((a: number, b: number) => a + b, 0);
        let roundSum = 0;

        // let data = "ag-Grid-AutoColumn-" + params.rowNode.field;
        // let autoGroup = params.rowNode.groupData[data];
        let autoGroup = params.rowNode.key;

        if (autoGroup) {
          roundSum = Math.round(sum);
        } else {
          roundSum = sum
        }
        return roundSum;
      }
    },
    'weightedPctAgg': (params: any) => {
      if (!this.rowData?.length || !params.rowNode) return 0;

      const pctField = params.colDef?.field;
      if (!pctField) return 0;
      const baseField = pctField.replace(/_pct$/, '');

      // Invalidate cache when rowData reference changes
      if (this._weightedPctCacheRowData !== this.rowData) {
        this._weightedPctCacheRowData = this.rowData;
        this._weightedPctCacheByNode = new WeakMap();
      }

      // Per-node cache: filter result + total_patients sum are reused across all percentage columns
      let nodeEntry = this._weightedPctCacheByNode.get(params.rowNode);
      if (!nodeEntry) {
        const condition: Record<string, any> = {};
        let current = params.rowNode;
        while (current && current.level >= 0 && current.field) {
          condition[current.field] = current.key;
          current = current.parent;
        }
        const condKeys = Object.keys(condition);

        // Single pass: filter rows AND accumulate total_patients
        const groupRows: any[] = [];
        let sumTotal = 0;
        for (const row of this.rowData) {
          let matches = true;
          for (let i = 0; i < condKeys.length; i++) {
            const k = condKeys[i];
            if (row[k] !== condition[k]) { matches = false; break; }
          }
          if (matches) {
            groupRows.push(row);
            sumTotal += Number(row['total_patients']) || 0;
          }
        }
        nodeEntry = { groupRows, sumTotal, fieldSums: new Map<string, number>() };
        this._weightedPctCacheByNode.set(params.rowNode, nodeEntry);
      }

      if (nodeEntry.sumTotal === 0 || nodeEntry.groupRows.length === 0) return 0;

      // Lazily compute per-baseField sum; each percentage column triggers this once per node
      let sumCount = nodeEntry.fieldSums.get(baseField);
      if (sumCount === undefined) {
        sumCount = 0;
        for (const row of nodeEntry.groupRows) {
          sumCount += Number(row[baseField]) || 0;
        }
        nodeEntry.fieldSums.set(baseField, sumCount);
      }

      return (sumCount / nodeEntry.sumTotal) * 100;
    },
    'sumWithPercent': (params: any) => {
      const values = params.values || [];
      return values.reduce((sum: number, v: number) => sum + (Number(v) || 0), 0);
    },
    'sumWithPercentTotal': (params: any) => {
      const values = params.values || [];
      return values.reduce((sum: number, v: number) => sum + (Number(v) || 0), 0);
    },
    'Grand Total': (params: any) => {return 'Grand Total'},
    'colorAggrSum': (params: any) => {

      if (this.rowData?.length > 0 && params.rowNode?.field) {
        const values = params.values;
        let sum = values.reduce((a: number, b: number) => a + b, 0);
        let roundSum = 0;

        // let data = "ag-Grid-AutoColumn-" + params.rowNode.field;
        // let autoGroup = params.rowNode.groupData[data];
        let autoGroup = params.rowNode.key;

        if (autoGroup) {
          roundSum = Math.round(sum);
        } else {
          roundSum = sum
        }
        return roundSum;
      }
    },
  }

  // Format number with commas (e.g., 1234 → 1,234)
  formatNumber(value: number): string {
    return this.currency.transform(value, '', '', '1.0-0') || value.toString();
  }

  // Dynamically calculate grand total row based on each column's aggFunc
  calculateGrandTotalRow(rowData: any[], columnDefs: any[]): any {
    // First pass: find the total column (sumWithPercentTotal) and compute its sum as the denominator
    let totalColumnSum = 0;
    const totalCol = columnDefs.find((col: any) => col.aggFunc === 'sumWithPercentTotal');
    if (totalCol?.field) {
      totalColumnSum = rowData.reduce((sum: number, row: any) => sum + (Number(row[totalCol.field]) || 0), 0);
    }

    // Second pass: compute sums for all sumWithPercent columns
    const sumWithPercentCols: any[] = [];
    for (const col of columnDefs) {
      if (col.field && (col.aggFunc === 'sumWithPercent' || col.aggFunc === 'sumWithPercentTotal')) {
        const colSum = rowData.reduce((sum: number, row: any) => sum + (Number(row[col.field]) || 0), 0);
        sumWithPercentCols.push({ field: col.field, sum: colSum, isTotal: col.aggFunc === 'sumWithPercentTotal' });
      }
    }

    return columnDefs.reduce((totals: any, col: any) => {
      const field = col.field;
      if (!field) return totals;

      const aggFunc = col.aggFunc;
      const values = rowData.map((row: any) => row[field]).filter((v: any) => v != null && v !== '');
      const numericValues = values.map((v: any) => Number(v)).filter((v: any) => !isNaN(v));

      if (aggFunc === 'Grand Total') {
        totals[field] = 'Total';
      } else if (aggFunc === 'sumWithPercent') {
        // Each column's percentage = column sum / Total column sum × 100
        const colData = sumWithPercentCols.find((c: any) => c.field === field);
        const colSum = colData?.sum || 0;
        const formattedSum = this.formatNumber(colSum);
        const pct = totalColumnSum > 0 ? ((colSum / totalColumnSum) * 100).toFixed(1) : '0';
        totals[field] = `${formattedSum} (${pct}%)`;
      } else if (aggFunc === 'sumWithPercentTotal') {
        // The Total column itself always shows sum (100%)
        const formattedTotal = this.formatNumber(totalColumnSum);
        totals[field] = `${formattedTotal} (100%)`;
      } else if (aggFunc === 'sum' || aggFunc === 'roundSum' || aggFunc === 'colorAggrSum') {
        totals[field] = numericValues.reduce((sum: number, v: number) => sum + v, 0);
        if (aggFunc === 'roundSum' || aggFunc === 'colorAggrSum') {
          totals[field] = Math.round(totals[field]);
        }
      } else if (aggFunc === 'avg' || aggFunc === 'average') {
        totals[field] = numericValues.length > 0
          ? numericValues.reduce((sum: number, v: number) => sum + v, 0) / numericValues.length
          : 0;
      } else if (aggFunc === 'min') {
        totals[field] = numericValues.length > 0 ? Math.min(...numericValues) : 0;
      } else if (aggFunc === 'max') {
        totals[field] = numericValues.length > 0 ? Math.max(...numericValues) : 0;
      } else if (aggFunc === 'count') {
        totals[field] = values.length;
      } else if (aggFunc === 'weightedPctAgg') {
        const baseField = field.replace(/_pct$/, '');
        let sumCount = 0;
        let sumTotal = 0;
        for (const row of rowData) {
          sumCount += Number(row[baseField]) || 0;
          sumTotal += Number(row['total_patients']) || 0;
        }
        totals[field] = sumTotal === 0 ? 0 : (sumCount / sumTotal) * 100;
      } else if (aggFunc === 'custom') {
        const valueCol = col.selectedRowConfig?.aggValueColumnName;
        const maxValueCol = col.selectedRowConfig?.aggMaxValueColumnName;
        if (valueCol && maxValueCol) {
          const sumValue = rowData.reduce((acc: number, row: any) => acc + (Number(row[valueCol]) || 0), 0);
          const sumMaxValue = rowData.reduce((acc: number, row: any) => acc + (Number(row[maxValueCol]) || 0), 0);
          totals[field] = (sumMaxValue === 0 && sumValue === 0) ? 0 : (sumValue / sumMaxValue) * 100;
        }
      } else if (!aggFunc) {
        totals[field] = undefined;
      } else {
        totals[field] = numericValues.length > 0
          ? numericValues.reduce((sum: number, v: number) => sum + v, 0)
          : undefined;
      }

      return totals;
    }, {});
  }

  // On User Sorted to Store the Col state
  onSortChanged(event: any) {
    this.userStateGenerated();
  }

  restoreState() {
    // debugger
    if(this.userActivityService.hierarchicalGridState?.length==0) return;
    let findState = this.userActivityService.hierarchicalGridState.find((o:any)=> o.dash_key == this.dashboardKey && o.tab_id == this.tabId);
    
    if(!this.columnApi) return false;
    if(!findState) return false;

    let colDefs = this.columnApi.columnModel.columnDefs;
    let colDef = colDefs.filter((f: any) => f.field != "hidden_column");

    let isPresents = colDef.filter((flr: any) => findState.colState.find((fnd: any) => flr['colId'] == fnd['colId']))
    let isPresent = isPresents.filter((f: any) => f.field != "hidden_column");

    if (isPresent.length == colDef.length) {
      this.columnApi.applyColumnState({
        state: findState.colState,
        applyOrder: true,
      });
    }
  }

  userStateGenerated() {
    const getRenderedRow = this.gridApi.getRenderedNodes();
    
    let getRenderedData = [];
    if(getRenderedRow.length) {
      for (let index = 0; index < getRenderedRow.length; index++) {
        const element = getRenderedRow[index];        
        const obj:any = {
          expanded: element.expanded,
          field: element.field,
          group: element.group,
          key: element.key
        }
        getRenderedData.push(obj);
      }
    }

    let obj = {
      'dash_key': this.dashboardKey,
      'tab_id': this.tabId,
      'colState': this.columnApi.getColumnState(),
      'getRenderedRow': getRenderedRow
    }

    if(this.userActivityService.hierarchicalGridState?.length) {
      let findUserState = this.userActivityService.hierarchicalGridState.findIndex((o:any)=> o.dash_key == this.dashboardKey && o.tab_id == this.tabId);
      if(findUserState!=-1) {
        this.userActivityService.hierarchicalGridState[findUserState] = obj;
      } else {
        this.userActivityService.hierarchicalGridState.push(obj);
      }
    } else {
      this.userActivityService.hierarchicalGridState.push(obj);
    }
  }

  private getDetailExcelRows(params: ProcessRowGroupForExportParams) {
    const detailData = params.node?.data?.callRecords || [];
    if (!detailData.length) return [];

    // Header row (dynamic from childColumnDefs)
    const headerRow = {
      outlineLevel: 1,
      cells: this.childColumnDefs.map((col: any) =>
        this.cell(col.headerName ?? col.field ?? "", "header")
      ),
    };

    // Data rows (dynamic from childColumnDefs + detailData)
    const detailRows = detailData.map((record: any) => ({
      outlineLevel: 1,
      cells: this.childColumnDefs.map((col: any) => {
        const field = col.field;
        let value = "";

        if (field && record.hasOwnProperty(field)) {
          value = record[field];
        }

        return this.cell(value, "body");
      }),
    }));

    return [headerRow, ...detailRows];
  }

  private cell(value: any, styleId?: string) {
    const safeValue = value == null ? "" : String(value); // safe always
    return {
      styleId,
      data: {
        type: "String",
        value: safeValue,
      },
    };
  }

  // Filter row data dynamically using the rowFilterKey emitted by the scatter chart
  filterRowDataByTerritoryKey(selectedInstitutions: any[], rowFilterKey?: string) {
    this.selectedInstitution = selectedInstitutions;
    this.lastRowFilterKey = rowFilterKey || '';

    // Use original unfiltered data as the source
    const sourceData = this.originalRowData.length > 0 ? this.originalRowData : this.rowData;

    // Extract the match values from the institution objects (always mapped to territoryKey property)
    const filterValues = selectedInstitutions
      .filter((inst: any) => inst.selected !== false)
      .map((inst: any) => inst.territoryKey);

    if (!filterValues.length) {
      this.resetTerritoryFilter();
      return;
    }

    // Resolve which row-data field to match against:
    // 1. rowFilterKey from emitted payload  2. item.config.filterKey  3. fallback
    const rowField: string = rowFilterKey
      || this.item?.config?.filterKey
      || 'territory_key';

    const filteredData = sourceData.filter((row: any) => filterValues.includes(row[rowField]));

    this.isFilteredByTerritory = true;

    // Update grid with filtered data
    if (this.gridApi) {
      this.gridApi.setRowData(filteredData);
      this.gridApi.refreshCells({ force: true });
    }
  }

  // Reset territory filter and restore all row data
  resetTerritoryFilter() {
    this.selectedInstitution = [];
    this.isFilteredByTerritory = false;

    if (this.originalRowData.length > 0 && this.gridApi) {
      this.gridApi.setRowData(this.originalRowData);
      this.gridApi.refreshCells({ force: true });
    }
  }


  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
